import styled from 'styled-components';
export const CashPickupIsReceiptDescription = () => {
  return (
    <Description>
      It may take up to <RedText>21 days</RedText> after customs
      <br />
      verification for your refund to be ready for cash
      <br />
      pickup at Western Union
    </Description>
  );
};

const Description = styled.div`
  color: var(--KTP-Grayscale-50, var(--KTP-Color-Mono-50, #80848a));
  text-align: center;

  /* Body/text-sm */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 19.6px */
  letter-spacing: -0.28px;
`;

const RedText = styled.span`
  color: var(--KTP-Warning-80, #ff2d55);
`;
